import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from "i18next-resources-to-backend";

const STORAGE_KEY = 'econtent-admin-lng';

function getInitialLanguage() {
    if (typeof window === 'undefined') return 'en';
    try {
        let saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'uk') {
            saved = 'ua';
            localStorage.setItem(STORAGE_KEY, 'ua');
        }
        if (saved === 'en' || saved === 'ua') return saved;
    } catch {
        /* ignore */
    }
    return 'en';
}

i18n
    .use(resourcesToBackend((lng, ns) => import(`./locales/${lng}/${ns}.json`))) // Динамічний імпорт
    .use(initReactI18next)      // Інтеграція з React
    .init({
        fallbackLng: 'en',
        lng: getInitialLanguage(),
        supportedLngs: ['en', 'ua'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
    });

export default i18n;


/*
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// мовні модулі
import en from './locales/en.json';
import ua from './locales/ua.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        ua: { translation: ua },
    },
    lng: 'en', // Мова за замовчуванням
    fallbackLng: 'en', // Резервна мова
    interpolation: {
        escapeValue: false, // Не потрібне екранування для React
    },
});

export default i18n;

/** 
 * Для зміни мови використовувати 
 * const { t } = useTranslation();
 * i18n.changeLanguage('ua');
 */
